import type {paths} from '../openapi/auth.swagger';
import {axiosInstance} from './axiosInstance';

type LoginOperation = paths['/executor_web/auth/login']['post'];

export type LoginRequest = NonNullable<NonNullable<LoginOperation['requestBody']>['content']['application/json']>;
export type LoginResponse = LoginOperation['responses'][200]['content']['application/json'];
export type LoginErrorResponse = LoginOperation['responses'][400]['content']['application/json'];

/** POST `/executor_web/auth/login` — см. `paths['/executor_web/auth/login']` в auth swagger */
export function login(request: LoginRequest, signal?: AbortSignal) {
	return axiosInstance.post<LoginResponse>('auth/login', request, {
		signal,
		headers: {'Accept-Language': 'RU'},
	});
}
